import { FC } from 'react';
import { ButtonGroupStyled } from './style';
import { Props } from '@/components/tour/game/FinishScreen/styled/ButtonGroup/types';

const ButtonGroup: FC<Props & { children?: any }> = ({ show, children, ...restProps }) =>
  show && <ButtonGroupStyled {...restProps}>{children}</ButtonGroupStyled>;

export default ButtonGroup;
